import * as React from 'react';
import classnames from 'classnames';
import { Hr } from '@grandvisionhq/elements';
import { useFeatureToggles } from '@grandvisionhq/state';
import '../../../context/actions.js';
import '../../../context/reducer.js';
import { useProductData } from '../../../context/product-context-hooks.js';
import '../../../context/ProductContext.js';
import '../../../context/CmsContext.js';
import { useProductDetailSlots } from '../../../slots/context.js';
import '../../../types/product.js';
import { isInStoreSubscriptionPurchase } from '../../../types/typeguards.js';
import '../../../hooks/useCartDiscountsQuery/types.js';
import '@grandvisionhq/graphql';
import '../../../operations/queries/get-accessories-by-slug.js';
import '../../../operations/queries/get-contact-lens-by-slug.js';
import '../../../operations/queries/get-frames-by-slug.js';
import '../../../operations/queries/get-solutions-by-slug.js';
import '../../../operations/queries/get-sunglasses-by-slug.js';
import '../../../operations/queries/get-ready-reader-by-slug.js';
import '../../../operations/queries/get-cart-discounts-by-promotion-identifier.js';
import '@grandvisionhq/utils';
import '../../../hooks/use-product-view-history.js';
import '@grandvisionhq/frk-routing';
import '@grandvisionhq/common';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/icons';
import '@grandvisionhq/forms';
import '@grandvisionhq/analytics';
import '@swc/helpers';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/svc-tealium/utils';
import '@grandvisionhq/inventory';
import '@grandvisionhq/lib-utils-html';
import '../../VTO/context/VtoProvider.js';
import 'usehooks-ts';
import 'use-onclickoutside';
import '@grandvisionhq/carts-v2';
import '@grandvisionhq/lib-visuals';
import { ProductTag } from '../components/ProductTag/ProductTag.js';
import { PriceSectionContainer } from '../components/PriceSection/PriceSectionContainer.js';
import { VariantSelectorTree } from '../components/VariantSelectorTree/VariantSelectorTree.js';
import '@grandvisionhq/content';
import { CLCartDiscountSelector } from './components/CLCartDiscountSelector/CLCartDiscountSelector.js';
import { CLDeliveryIndicator } from './components/CLDeliveryIndicator/CLDeliveryIndicator.js';
import { CLDeliveryIntervalSelect } from './components/CLDeliveryIntervalSelect/CLDeliveryIntervalSelect.js';
import { CLPrescriptionSelector } from './components/CLPrescriptionSelector/CLPrescriptionSelector.js';
import { CLPurchaseTypeSelectionBoxes } from './components/CLPurchaseTypeSelectionBoxes/CLPurchaseTypeSelectionBoxes.js';
import { ContactLensesCTA } from './components/ContactLensesCTA/ContactLensesCTA.js';
import { useCLEcommContext } from './context/CLEcommContext.js';
import './operations/queries/get-contact-lens-by-prescription.js';

const ContactLensesEcommContent = ({ className , ctaRef  })=>{
    const { isContactLensEnabled  } = useFeatureToggles();
    const { activeVariant: { displayName , isExcludedFromCheckout  } ,  } = useProductData();
    const { Slots  } = useProductDetailSlots();
    const { state: { configurations: { purchaseType  } ,  } ,  } = useCLEcommContext();
    const onlinePurchasingAllowed = isContactLensEnabled && !isExcludedFromCheckout;
    const inStoreSubscriptionPurchaseSelected = isInStoreSubscriptionPurchase(purchaseType);
    return /*#__PURE__*/ React.createElement("section", {
        "aria-label": displayName,
        className: classnames('contact-lenses-ecomm-content', className)
    }, /*#__PURE__*/ React.createElement(ProductTag, {
        className: "contact-lenses-ecomm-content__tag"
    }), /*#__PURE__*/ React.createElement(PriceSectionContainer, null), /*#__PURE__*/ React.createElement(Hr, null), /*#__PURE__*/ React.createElement(VariantSelectorTree, null), /*#__PURE__*/ React.createElement("div", {
        className: "contact-lenses-ecomm-content__column"
    }, onlinePurchasingAllowed && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(CLPurchaseTypeSelectionBoxes, null), /*#__PURE__*/ React.createElement(CLDeliveryIntervalSelect, null), /*#__PURE__*/ React.createElement(CLCartDiscountSelector, null)), onlinePurchasingAllowed && !inStoreSubscriptionPurchaseSelected && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(CLPrescriptionSelector, null), /*#__PURE__*/ React.createElement(CLDeliveryIndicator, null)), /*#__PURE__*/ React.createElement("div", {
        ref: ctaRef
    }, /*#__PURE__*/ React.createElement(ContactLensesCTA, null)), Slots.AfterCTA && /*#__PURE__*/ React.createElement(Slots.AfterCTA, null)));
};

export { ContactLensesEcommContent };
//# sourceMappingURL=ContactLensesEcommContent.js.map
